module.exports = __webpack_public_path__ + "img/@logo_happy.2b2268a4.png";